// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__ITp-N","sliderContainer":"Slider_sliderContainer__-8BGl","helper":"Slider_helper__oMN9H"};